import { createTheme } from "@mui/material";

import { palette } from './palette';
import { typography } from './typography';
import { components } from './components';

declare module '@mui/material/styles' {
    interface PaletteColor {
        50?: string;
        100?: string;
        200?: string;
        300?: string;
        400?: string;
        500?: string;
        600?: string;
        700?: string;
        800?: string;
        900?: string;
    }

    interface SimplePaletteColorOptions {
        50?: string;
        100?: string;
        200?: string;
        300?: string;
        400?: string;
        500?: string;
        600?: string;
        700?: string;
        800?: string;
        900?: string;
    }

    interface TypographyVariants {
        display1: React.CSSProperties;
        display2: React.CSSProperties;
        technical: React.CSSProperties;
    }

    interface TypographyVariantsOptions {
        display1?: React.CSSProperties;
        display2?: React.CSSProperties;
        technical?: React.CSSProperties;
    }
}

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        display1: true;
        display2: true;
        technical: true;
    }
}

export const theme = createTheme({
    palette,
    typography,
    components,
});
